import React, { useState, useEffect } from "react";
import "./ScrollToTop.css";
import { useLocation, useNavigationType } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import Scroll_to_top from "../../luxury_components/animation/Scroll_to_top/Scroll_to_top";

const ScrollToTop = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const [isVisible, setIsVisible] = useState(false);

  // Show / Hide button on scroll
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top when button clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // ✅ Auto scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.key, navigationType]);

  // Handle scroll listener for button
  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className="scroll-to-top">
      {isVisible && (
        // <button onClick={scrollToTop} className="scroll-button">
        //   <FontAwesomeIcon icon={faArrowUp} />
        // </button>
          <Scroll_to_top  onClick={scrollToTop}/>
      )}
    </div>
  );
};

export default ScrollToTop;
